<template>
  <div class="userinfo-school">
    <div class="school">{{ schoolName }}</div>
    <div class="content-line"></div>
    <div @click="addClick" class="add">
      <i class="iconfont icon-add" />添加绑定班级
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      class="content-form"
    >
      <el-form-item v-for="i in classNum" :key="i">
        <el-col :span="10">
          <el-form-item label="班级:">
            <el-cascader
              v-model="ruleForm.classList[i - 1].gradeClass"
              placeholder="请选择班级"
              :options="classSelect"
              :props="classProps"
              @change="handleChange"
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="10">
          <el-form-item label="职称:">
            <el-select
              v-model="ruleForm.classList[i - 1].isCharge"
              placeholder="请选择职称"
            >
              <el-option
                :label="item.roleName"
                :value="item.isCharge"
                v-for="(item, index) in roleList"
                :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2"
          ><div @click="reduceClick(i - 1)" class="reduce">
            <i class="iconfont icon-noboder-delete"></i></div
        ></el-col>
      </el-form-item>
    </el-form>
    <div class="content-line"></div>
    <div class="content-btn">
      <div class="btn" @click="previous">上一步</div>
      <div class="btn" @click="submitForm('ruleForm')">完成</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    schoolName: {
      type: String,
      require: true,
    },
    // 后端给的班级列表
    classSelectList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    roleList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      classNum: 1,
      // 表单数据
      ruleForm: {
        classList: [
          {
            gradeClass: [],
            isCharge: "",
          },
        ],
      },
      // 表单规则
      rules: {
        className: [
          { required: true, message: "请选择班级", trigger: "change" },
        ],

        // courseIndex: [
        //   { required: true, message: "请选择科目", trigger: "change" },
        // ],

        isCharge: [
          { required: true, message: "请选择职称", trigger: "change" },
        ],
      },
      // schoolName: "广州天河区实验中学",
      // 级联选择器属性配置
      classProps: {
        expandTrigger: "hover",
        children: "schoolClassList",
      },
      // 级联选择器的班级列表
      classSelect: [],
      // 提交传给后端的数据
      submitList: [],
    };
  },
  created() {
    // console.log(this.classSelectList);
    // 将classSelectList处理成级联选择器需要的格式
    if (this.classSelectList.length) {
      this.classSelectList.forEach((gItem, g) => {
        let { gradeCode, gradeId, gradeName } = gItem;
        gItem.value = {
          gradeCode,
          gradeId,
          gradeName,
        };
        gItem.label = gItem.gradeName;
        gItem.schoolClassList.forEach((cItem, c) => {
          let { classCode, classId, className } = cItem;
          cItem.value = {
            classCode,
            classId,
            className,
          };
          cItem.label = cItem.className;
        });
      });
      // console.log(this.classSelectList);
      this.classSelect = this.classSelectList;
    }
  },
  methods: {
    // 选择班级
    handleChange(value) {
      // console.log(value);
    },
    //
    previous() {
      this.$emit("previous");
    },
    // 添加选择器
    addClick() {
      this.ruleForm.classList.push({
        gradeClass: [],
        isCharge: "",
      });
      this.classNum++;
    },
    // 减少选择器
    reduceClick(i) {
      // console.log(i);
      if (this.classNum == 1) {
        return this.$message.warning("至少需要绑定一个班级");
      }
      this.ruleForm.classList.splice(i, 1);
      this.classNum--;
    },
    // 点击完成
    submitForm(formName) {
      // console.log(this.ruleForm);
      this.submitList = [];
      for (let i = 0; i < this.ruleForm.classList.length; i++) {
        // 有未选择的班级或职称
        if (
          this.ruleForm.classList[i].gradeClass.length == 0 ||
          this.ruleForm.classList[i].isCharge === ""
        ) {
          return this.$message.error("有未选择的班级或职称");
        }
        // 遍历this.submitList，查看是否有重复的班级
        let list = this.submitList.filter((sItem) => {
          return (
            sItem.gradeId == this.ruleForm.classList[i].gradeClass[0].gradeId &&
            sItem.classId == this.ruleForm.classList[i].gradeClass[1].classId
          );
        });
        // console.log(list);
        // 有重复选择的班级
        if (list.length > 0) {
          return this.$message.error("有重复选择的班级");
        } else {
          // 添加到this.submitList中
          let { id: createBy, schoolId, schoolName, id: teacherId, teacherNumber, teacherName } = this.user;
          this.submitList.push({
            createBy,
            schoolId,
            schoolName,
            teacherId,
            teacherNumber,
            teacherName,

            gradeId: this.ruleForm.classList[i].gradeClass[0].gradeId,
            gradeName: this.ruleForm.classList[i].gradeClass[0].gradeName,
            gradeCode: this.ruleForm.classList[i].gradeClass[0].gradeCode,
            classId: this.ruleForm.classList[i].gradeClass[1].classId,
            className: this.ruleForm.classList[i].gradeClass[1].className,
            classCode: this.ruleForm.classList[i].gradeClass[1].classCode,
            isCharge: this.ruleForm.classList[i].isCharge,
          });
        }
      }
      // console.log("this.submitList提交给后端的数据=>", this.submitList);
      this.$emit("submit", {
        submitList: this.submitList,
      });
    },
  },
};
</script>

<style lang="scss" scoped >
@import "userinfo-school.scss";
</style>